<script setup lang="ts">
import dayjs from "dayjs";
import type { BranchFiles, DirectusFiles } from "~/types/directus-collections.d.ts";

const props = defineProps<{
  file: BranchFiles & { file: DirectusFiles };
  token: string | null;
}>();

const fileIcon = computed(() => {
  switch (props.file.file.type) {
    case "application/pdf":
      return "fa-solid fa-file";
    case "image/jpeg":
      return "fa-solid fa-image";
    default:
      return "fa-solid fa-link";
  }
});

const config = useRuntimeConfig();

const dateUploaded = computed(() => {
  return dayjs(props.file.date_created).format("D MMM, YYYY");
});

const fileURL = computed(() => {
  let url;

  if (props.token !== null && props.file.is_public === false) {
    url = config.public.directusUrl + "/assets/" + props.file.file.id + "&access_token=" + props.token;
  } else {
    url = config.public.directusAssetsUrl + "/api/" + props.file.file.filename_disk;
  }

  if (props.file.file.type === "application/pdf") {
    url += "?download";
  }

  return url;
});
</script>

<template>
  <div
    class="mb-8 grid min-h-24 grid-cols-6 items-center gap-7 rounded-lg border-2 border-secondary p-4 xl:grid-cols-12 xl:border-none xl:p-0"
  >
    <div class="col-span-1 flex size-12 items-center justify-center rounded-full bg-primary text-white">
      <font-awesome-icon :icon="fileIcon" />
    </div>
    <div class="col-span-5 text-2xl font-semibold xl:col-span-3">
      {{ file.file.title }}
    </div>
    <div class="col-span-6 flex h-full items-center border-secondary text-lg font-normal xl:col-span-5 xl:border-l-4 xl:pl-7">
      {{ file.file.description ? file.file.description : "No description" }}
    </div>
    <div class="col-span-3 text-right xl:col-span-1">
      {{ dateUploaded }}
    </div>
    <a
      class="group relative col-span-3 flex w-full cursor-pointer items-center justify-center space-x-2 rounded-full bg-secondary px-8 py-5 text-base text-accentDark transition hover:bg-primary hover:text-white xl:col-span-2"
      :href="fileURL"
    >
      {{ file.file.type === "application/pdf" ? "Download" : "View" }}
    </a>
  </div>
</template>
